import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentRepoConfigResponse } from "@types";

export const fetchDeploymentRepoConfig = (
  deploymentId: string,
  repoPath: string
): Promise<DeploymentRepoConfigResponse> => {
  const url = `${DEPLOYMENT_URL}/${deploymentId}/repos/${repoPath}/_config`;
  return authGet<DeploymentRepoConfigResponse>(url);
};
